import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { EMPTY, of } from 'rxjs';

import { BaseFormComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { Movement, MovementMeta } from '@atmi/core/models';
import { formatDateStrToIT, getFormatDate, getValidDateFromIT } from '@atmi/core/utils';
import { map } from 'rxjs/operators';

export interface MovementData {
  movement?: Movement;
  classNames: ClassName[];
}

@Component({
  selector: 'app-movement-dialog',
  styleUrls: ['./movement-dialog.component.scss'],
  templateUrl: './movement-dialog.component.html',
})
export class MovementDialogComponent extends BaseFormComponent<Movement> {

  readonly title = this.data.movement
    ? this.translate.instant('Modifica movimento')
    : this.translate.instant('Aggiungi movimento');

  readonly mainActionLabel = this.data.movement
    ? this.translate.instant('Salva')
    : this.translate.instant('Crea');

  constructor(
    private readonly dialogRef: MatDialogRef<MovementDialogComponent>,
    protected readonly formManager: FormManagerService,
    protected readonly translate: TranslateService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly spinner: NgxSpinnerService,
    protected readonly cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public readonly data: MovementData,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      cd,
      MovementMeta,
      () => of(data.movement).pipe(map((m) => {
        return m
          ? {
            ...m,
            dataRientro: m.dataRientro && formatDateStrToIT(m.dataRientro),
            dataUscita: m.dataUscita && formatDateStrToIT(m.dataUscita),
          }
          : undefined;
      })),
    );
  }

  addConcrete() {
    return EMPTY;
  }

  removeConcrete() {
    return EMPTY;
  }

  editConcrete() {
    return EMPTY;
  }

  resetFormConcrete() {
    return this.entityForm.reset();
  }

  completeHandler() {
    if (this.entityForm.value) {
      const value = this.entityForm.value;

      const movement: Movement = {
        ...value,
        dataRientro: value.dataRientro ? getFormatDate(getValidDateFromIT(value.dataRientro)) : null,
        dataUscita: value.dataUscita ? getFormatDate(getValidDateFromIT(value.dataUscita)) : null,
      };
      this.dialogRef.close(movement);
    } else {
      this.entityForm.markAllAsTouched();
    }
  }

}
